import { render, staticRenderFns } from "./GameSpeedH5.vue?vue&type=template&id=0c819ec5&scoped=true"
import script from "./GameSpeedH5.vue?vue&type=script&lang=js"
export * from "./GameSpeedH5.vue?vue&type=script&lang=js"
import style0 from "./GameSpeedH5.vue?vue&type=style&index=0&id=0c819ec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c819ec5",
  null
  
)

export default component.exports